import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/leave-management-system/leave-types/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-types" entry is kept); the seo block below is a fallback.

export const leaveTypes: ContentPage = {
  slug: "leave-management-system/leave-types",
  template: "hrmsFeature",
  seo: {
    title: "Leave Types Management - Customize Employee Leave Policies",
    description: "Easily manage various leave types such as vacation, sick leave, and unpaid leave. Customize leave policies for each type with our Leave Types Management system.",
    keywords: [
      "leave types management",
      "custom leave types",
      "employee leave policies",
      "sick leave management",
      "vacation leave system",
      "HR leave tracking",
    ],
    ogImage: "/assets/data/seoimages/leave-types.webp",
  },
  leaf: {
    hero: {
      caption: "Leave Types",
      title: "Manage Multiple Leave Types with Customizable Policies",
      description: "Easily manage and customize various leave types such as vacation, sick leave, and unpaid leave to meet the needs of your business and employees.",
      h1: "caption",
    },
    split: {
      title: "Leave Type Management for Enhanced Efficiency",
      bullets: [
        { title: "Multiple Leave Types", description: "Support diverse leave types, including vacation, sick leave, unpaid, and custom options." },
        { title: "Custom Leave Policies", description: "Define specific entitlements, accruals, and carry-forward rules for different leave categories." },
        { title: "Type-Specific Approvals", description: "Establish distinct approval processes for each leave type to ensure appropriate oversight." },
        { title: "Detailed Leave Reporting", description: "Generate comprehensive reports to monitor leave usage patterns and track absenteeism." },
      ],
      image: "/assets/images/img/product/hrms/leavems/leave-types.webp",
      imageAlt: "leave-types",
    },
    cardsHeading: {
      title: "Key Features of Leave Management System",
      description: "Optimize leave management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Leave Accrual Details",
        href: "/hrms-software/leave-management-system/leave-accrual-details",
        description: "Automate the calculation of leave accruals to ensure accurate and fair leave tracking, eliminating manual errors.",
        image: "/assets/images/img/product/hrms/leavems/leave_accrual_details.webp",
        imageAlt: "leave_accrual_details",
      },
      {
        title: "Leave Policy & Allocation",
        href: "/hrms-software/leave-management-system/leave-policy-allocation",
        description: "Create and manage leave policies tailored to your organization’s needs. Allocate leaves based on roles, seniority, and more.",
        image: "/assets/images/img/product/hrms/leavems/leave_policy_and_allocation.webp",
        imageAlt: "leave_policy_and_allocation",
      },
      {
        title: "Easy Approval",
        href: "/hrms-software/leave-management-system/leave-approval/",
        description: "Facilitate quick and easy leave request approvals or declines with a user-friendly workflow, keeping your HR processes efficient.",
        image: "/assets/images/img/product/hrms/leavems/easy_approval_decline.webp",
        imageAlt: "easy_approval_decline",
      },
      {
        title: "Leave Balance",
        href: "/hrms-software/leave-management-system/leave-balance",
        description: "Keep track of employee leave balances in real-time, ensuring transparency and accurate record-keeping.",
        image: "/assets/images/img/product/hrms/leavems/leave_balance_features.webp",
        imageAlt: "leave_balance",
      },
    ],
    testimonials: {
      title: "What Our Customers Say",
      description: "Our clients consistently praise the design and functionality of our templates.",
    },
    bookDemoTitle: "Optimize Leave Types Discover Custom Solutions Now",
    relatedBlogsKeyword: "what-is-hrms,leave-management-software-sme",
    metaKey: "leave-types",
  },
  sections: [],
};
